// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

export { lightTheme } from './light';
export { darkTheme } from './dark';

export { StyledReset } from './StyledReset';
export { GlobalStyles } from './GlobalStyles';
